import { Client } from "@stomp/stompjs";

let stompClient = null;

export const connectWebSocket = (onOrderReceived) => {
  if (stompClient && stompClient.active) {
    return; // prevent multiple connections
  }

  stompClient = new Client({
    brokerURL: "wss://backend.wassiniluxury.com/ws",
    reconnectDelay: 5000,
    debug: (str) => console.log(str),

    onConnect: () => {
      console.log("WebSocket connected");

      stompClient.subscribe("/topic/orders", (message) => {
        const order = JSON.parse(message.body);
        onOrderReceived(order);
      });
    },

    onStompError: (frame) => {
      console.error("Broker error:", frame);
    }
  });

  stompClient.activate();
};

export const disconnectWebSocket = () => {
  if (stompClient) {
    stompClient.deactivate();
    stompClient = null;
  }
};
